import { render, staticRenderFns } from "./SetDefaultCrateProtocolDialog.vue?vue&type=template&id=254d5b67&"
import script from "./SetDefaultCrateProtocolDialog.vue?vue&type=script&lang=js&"
export * from "./SetDefaultCrateProtocolDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports